<div id="dimmer">
  <span class="loading-message">{{ loadingMessage }}</span>
</div>
